<div class="order-factor">
  <div
    class="factortotalpricebox"
    [class.factortonopentalprice]="invoiceservice.order.OrderSetting ? invoiceservice.order.OrderSetting.IsShowTotalBox : false">
    <div class="factorbox">
      <div
        class="showheader"
        (click)="
          invoiceservice.order.showHeader = !invoiceservice.order.showHeader;
          invoiceservice.order.common.updateSettings(invoiceservice.order.OrderSetting)
        ">
        <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.CustomerInformation" | translate }}</span>
        <i [ngClass]="{ 'icon-chevron-up': invoiceservice.order.showHeader, 'icon-chevron-down': !invoiceservice.order.showHeader }"></i>
      </div>

      <div
        class="header"
        [class.headerheight]="invoiceservice.order.showHeader"
        [class.mobilehead]="invoiceservice.order.showHeader"
        [class.headerbox]="
          !invoiceservice.order.invoice.CustomerAddress &&
          !invoiceservice.order?.saleMethodBranch?.ShowNumberOfGuests &&
          !invoiceservice.order?.saleMethodBranch?.ShowWaiterName
        ">
        <div class="customername" *ngIf="invoiceservice.order.OrderSetting && invoiceservice.order.OrderSetting.showComplate">
          <div
            *ngIf="
              invoiceservice.order.OrderSetting &&
              (invoiceservice.order?.saleMethodBranch?.ShowCustomerInfo ||
                invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery)
            "
            class="customerwidth">
            <div
              class="d-flex customer"
              (click)="invoiceservice.order.hideFastAccess = true; invoiceservice.openFastAccess(invoiceservice.fastAccessEnum.Customer, $event)">
              <span class="custmertitle"> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.CustomerName" | translate }}: </span>
              <span class="mr-1" *ngIf="invoiceservice.order.invoice">{{ invoiceservice.order.invoice.CustomerDisplayName }}</span>
            </div>
            <span *ngIf="invoiceservice.order.invoice && invoiceservice.order.invoice.CustomerDisplayName">
              <i class="icon-cancel-circle garsonicon" (click)="invoiceservice.DeleteCustomer()"></i>
            </span>
          </div>
          <div
            *ngIf="
              invoiceservice.order?.saleMethodBranch?.ShowCustomerInfo ||
              invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery
            "
            class="customercodewidth d-flex">
            <div>
              <span class="customerid">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.CustomerCode" | translate }} : </span>
              <span *ngIf="invoiceservice.order.invoice.Customer" class="customercode">{{ invoiceservice.order.invoice.Customer?.Number }}</span>
            </div>
            <div class="addFreeCustomerIcon">
              <span *ngIf="invoiceservice.order.invoice.Customer?.Party?.Number == 0" style="font-size: 1rem">
                <i class="icon icon-person_add_alt_1-o" (click)="invoiceservice.addFreeCustomer()"></i>
              </span>
            </div>
          </div>
          <ssg-select
            name="SalePriceTypeId"
            class="pricemodel"
            [class.deactive-sprice]="!invoiceservice.order.salePricePermission"
            [group]="invoiceservice.order.formGroup"
            textFieldName="Title"
            valueFieldName="Id"
            [dataList]="invoiceservice.order.salePriceType"
            [searchable]="false"
            [selectOnTab]="false"
            [clearable]="false"
            (valueChange)="invoiceservice.SalePriceChange($event)"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ValueFieldName' | translate">
          </ssg-select>

          <div *ngIf="invoiceservice.order?.saleMethodBranch?.ShowWaiterName" class="garsonname">
            <span (click)="invoiceservice.order.hideFastAccess = true; invoiceservice.openFastAccess(invoiceservice.fastAccessEnum.Waiter, $event)"
              >{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.HostName" | translate }}:
            </span>
            <span class="customer" *ngIf="invoiceservice.order.invoice">{{ invoiceservice.order.invoice.WaiterName }}</span>
            <span class="icon" *ngIf="invoiceservice.order.invoice && invoiceservice.order.invoice.WaiterName">
              <i class="icon-cancel-circle garsonicon" (click)="invoiceservice.DeleteWaiter()"></i>
            </span>
          </div>
          <div
            (click)="invoiceservice.openFastAccess(invoiceservice.fastAccessEnum.Salon, $event)"
            *ngIf="
              invoiceservice.order?.saleMethodBranch?.ShowSalonName &&
              invoiceservice.order.currentSaleMethodNature !== invoiceservice.order.SaleMethodNature.Delivery
            "
            class="salonwidth d-flex">
            {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.SalonName" | translate }}:
            <span class="salonname" *ngIf="invoiceservice.order.invoice">{{ invoiceservice.order.invoice.TableTitle }}</span>
          </div>
          <div class="personbox" *ngIf="invoiceservice.order?.saleMethodBranch?.ShowNumberOfGuests">
            <div class="person">
              <i alt="plus" class="plusicon mobicon icon-add-o" id="plusicon" (click)="invoiceservice.changeNumberOfGuests(1)"></i>
              <ssg-input
                [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.NumberOfGuests' | translate"
                name="NumberOfGuests"
                [group]="invoiceservice.order.formGroup"
                class="guestnumber"
                textType="currency"
                isNumberOnly="true"></ssg-input>
              <i alt="minus" class="minusicon mobicon icon-remove-o" id="minusicon" (click)="invoiceservice.changeNumberOfGuests(2)"></i>
            </div>
          </div>
          <div class="addresinfo" *ngIf="invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery">
            <span class="addresstitle">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Address" | translate }}:</span>
            <div class="adress" *ngIf="invoiceservice.order.invoice.CustomerAddress" [tooltip]="invoiceservice.order.invoice.CustomerAddress.Address">
              {{ (invoiceservice.order.invoice.CustomerAddress?.Zone?.Title || "") + " - " + invoiceservice.order.invoice.CustomerAddress.Address }}
            </div>
          </div>
          <div class="tellbox" *ngIf="invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Phone" | translate }}:</span>
            <div class="adress">
              {{ invoiceservice.order.invoice.PhoneNumber }}
            </div>
          </div>
          <ssg-select
            name="BranchId"
            *ngIf="
              invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery && invoiceservice.order.isMultiBranch
            "
            class="callcenter-branch"
            [group]="invoiceservice.order.formGroup"
            textFieldName="Title"
            [dataList]="invoiceservice.order.CallCenterLookUp"
            valueFieldName="Id"
            [searchable]="false"
            [selectOnTab]="false"
            [clearable]="false"
            (valueChange)="afterChangeBranchFromView($event?.Id)"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Branch' | translate"></ssg-select>
        </div>
        <div class="detailbox" *ngIf="invoiceservice.order.OrderSetting && !invoiceservice.order.OrderSetting.showComplate">
          <div class="detail">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.DebtRate" | translate }} : </span>
            <span>{{ invoiceservice.order.invoice.Customer?.DebitRate | number }}</span>
          </div>
          <div class="detail">
            <span> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.DateOfLastPurchase" | translate }}: </span>
            <span>{{ invoiceservice.order.invoice.Customer?.LastBuyDate }}</span>
          </div>

          <div class="detail">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.MostPurchases" | translate }} : </span>
            <span>{{ invoiceservice.order.invoice.Customer?.MaximumBuy | number }}</span>
          </div>
          <div class="detail">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ArrivingTime" | translate }} : </span>
            <span>{{ invoiceservice.order.invoice.Customer?.MinutesToDelivery }}</span>
          </div>
          <div class="detail des">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Description" | translate }}: </span>
            <span>{{ invoiceservice.order.invoice.Customer?.Description }}</span>
          </div>
        </div>
        <div
          class="tabcontain"
          *ngIf="
            invoiceservice.order?.saleMethodBranch?.ShowCustomerInfo ||
            invoiceservice.order.currentSaleMethodNature === invoiceservice.order.SaleMethodNature.Delivery
          ">
          <div
            class="infobox"
            [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.CustomerInformation' | translate"
            (click)="invoiceservice.order.OrderSetting.showComplate = true"
            [class.selectTab]="invoiceservice.order.OrderSetting ? invoiceservice.order.OrderSetting.showComplate : false">
            <i class="icon-account_circle-o"></i>
          </div>
          <div
            class="infobox"
            [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ComplateInformation' | translate"
            (click)="invoiceservice.order.OrderSetting.showComplate = false"
            [class.selectTab]="invoiceservice.order.OrderSetting ? !invoiceservice.order.OrderSetting.showComplate : true">
            <i class="icon-info-24px"></i>
          </div>
        </div>
      </div>
      <div class="salontitle">
        <span class="icon" (click)="invoiceservice.changeQuantity(null, invoiceservice.itemStateEnum.Clear)">
          <i class="icon-trash-o"></i>
        </span>
        <span class="item name">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Title" | translate }}</span>
        <span class="item">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Count" | translate }}</span>
        <span class="item price">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Price" | translate }}</span>
        <span class="item sum"> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.SumPrice" | translate }}</span>
      </div>
      <div
        class="factor"
        id="factor{{ invoiceservice.order.invoice.SaleMethodBranchId }}"
        [class.orderfactor]="!invoiceservice.order?.saleMethodBranch?.ShowNumberOfGuests && !invoiceservice.order?.saleMethodBranch?.ShowWaiterName">
        <div
          #factorss
          *ngFor="let item of invoiceservice.order.invoice.Items; let itemindex = index"
          class="bgwhite"
          [class.selecteditem]="this.invoiceservice.order.selectedOrderItemIndex === itemindex"
          (click)="invoiceservice.setSelectedItem(item, itemindex)">
          <div class="content" [id]="item.Index?.toString()">
            <div class="detail">
              <span class="icon mobicon" (click)="invoiceservice.changeQuantity(item, invoiceservice.itemStateEnum.Remove)">
                <i class="icon-cancel-circle"></i>
              </span>
              <span class="item prname">{{ item.ItemTitle }}</span>
              <div class="item number" (click)="$event.stopPropagation()">
                <i
                  class="operation icon-add_circle_outline-o mobicon"
                  *ngIf="!item?.IsClubItem"
                  (click)="invoiceservice.changeQuantity(item, invoiceservice.itemStateEnum.Increase)"></i>
                <ssg-input
                  class="count-food"
                  name="itemsQuantity{{ item.Index }}{{ invoiceservice.order.invoice.SaleMethodBranchId }}"
                  [group]="invoiceservice.order.formGroup"
                  [hideBorder]="true"
                  textType="currency"
                  isNumberOnly="true"
                  [isFloat]="invoiceservice.order?.currentBranch?.HasDecimal || false"
                  (focusout)="invoiceservice.changeQuantity(item, invoiceservice.itemStateEnum.NoAction)"
                  (onEnter)="invoiceservice.changeQuantity(item, invoiceservice.itemStateEnum.NoAction)"></ssg-input>
                <i
                  class="operation icon-remove_circle_outline-o mobicon"
                  *ngIf="!item?.IsClubItem"
                  (click)="invoiceservice.changeQuantity(item, invoiceservice.itemStateEnum.Decrease)"></i>
              </div>
              <span class="item price">{{ item.UnitPrice + item.UnitAdditive | number }}</span>
              <span class="item sum">{{ item.ItemTotal | number }}</span>
              <span
                class="item desfactor mobicon"
                *ngIf="!invoiceservice.order.invoice.HasClub"
                (click)="invoiceservice.ShowRowDiscount(item); $event.stopPropagation()"
                ><i class="icon-Percent"></i
              ></span>
            </div>
          </div>
          <div class="material">
            <span class="material-des">{{ item.Description }}</span>
            <div class="material-percent" [class.show-percent]="item.showPercent" *ngIf="item.showPercent">
              <ssg-input
                [group]="invoiceservice.order.formGroup"
                name="RowDiscount{{ item.Index }}{{ invoiceservice.order.invoice.SaleMethodBranchId }}"
                [disabled]="item?.IsClubItem"
                textType="text"
                [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Sale' | translate"
                class="percent-input"
                [isFloat]="invoiceservice.order?.currentBranch?.HasDecimal || false"
                [withComma]="true"
                isshow="true"
                hasClear="true"
                autocomplete="off"
                isNumberOnly="true"
                inputMode="numeric"
                (focusout)="invoiceservice.RowDiscountChange(item.Index)"
                (onEnter)="invoiceservice.RowDiscountChange(item.Index)"
                (clear)="invoiceservice.clearRowDiscount()"
                [class.show-percent-input]="invoiceservice.order.OrderSetting ? invoiceservice.order.OrderSetting.showPercent : false"
                userClass="select-shr">
              </ssg-input>
              <span class="percent-price"
                >{{ ((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100 | number }}
                {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.UnitPrice" | translate }}</span
              >
            </div>
            <i *ngIf="item?.Description?.length > 0" class="icon-close-o" (click)="invoiceservice.clearDescription(item)"></i>
          </div>
        </div>
      </div>
      <div class="footerbox">
        <div class="factordes">
          <ssg-input
            *ngIf="invoiceservice.order?.saleMethodBranch?.ShowDescInvKitchen"
            [group]="invoiceservice.order.formGroup"
            (input)="invoiceservice.OnChangedDescription($event, 'DescKitchen')"
            name="DescKitchen"
            maxLength="250"
            textType="text"
            inputMode="text"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ShowDescInvKitchen' | translate">
          </ssg-input>

          <ssg-input
            *ngIf="invoiceservice.order?.saleMethodBranch?.ShowDescInvCustomer"
            [group]="invoiceservice.order.formGroup"
            (input)="invoiceservice.OnChangedDescription($event, 'DescCustomer')"
            name="DescCustomer"
            textType="text"
            maxLength="250"
            inputMode="text"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.ShowDescInvCustomer' | translate">
          </ssg-input>
          <ssg-input
            *ngIf="!(invoiceservice.order?.saleMethodBranch?.ShowDescInvKitchen || invoiceservice.order?.saleMethodBranch?.ShowDescInvCustomer)"
            [group]="invoiceservice.order.formGroup"
            (input)="invoiceservice.OnChangedDescription($event, 'Description')"
            name="Description"
            maxLength="500"
            textType="text"
            inputMode="text"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.Desktop.Description' | translate">
          </ssg-input>
        </div>
        <div class="totalprice" [class.onopentalprice]="invoiceservice.order.OrderSetting ? invoiceservice.order.OrderSetting.IsShowTotalBox : false">
          <order-totalprice></order-totalprice>
        </div>
      </div>
    </div>
  </div>
</div>
